<template>
  <a @click="$emit('close-visitor')">
    <img v-if="visitor.access"
         class="icon-pdf"
         :src="iconPath('v_accept.svg')"
         alt="Разрешить доступ"/>
    <img v-else
         :src="iconPath('v_denied.svg')"
         class="icon-pdf"
         alt="Запретить доступ"/>
    {{ visitor.access ? 'Разрешить доступ' : 'Запретить доступ' }}
  </a>
</template>

<script>
export default {
  name: 'GiveAccessButton',

  props: {
    visitor: {
      type: Object
    }
  },

  methods: {
    iconPath(baseName) {
      return require('@/common/assets/img/icons/menuVisitor/' + baseName)
    }
  }

}
</script>

<style scoped>

</style>
